export var screenSize = {
    sm: '@media all and (max-width: 720px) and (max-resolution: 4dppx), all and (max-width: 720px) and (-webkit-max-device-pixel-ratio: 4)',
    md: '@media all and (max-width: 1200px) and (max-resolution: 4dppx), all and (max-width: 1200px) and (-webkit-max-device-pixel-ratio: 4)',
    lg: '@media all and (min-width: 1920px) and (max-resolution: 4dppx), all and (min-width: 1920px) and (-webkit-max-device-pixel-ratio: 4)',
};
//# sourceMappingURL=ScreenSize.js.map